export default {
  INFO: 'info',
  UPSELLS: 'upsells',
  PRODUCTS: 'products',
  TRACKING: 'tracking',
  CROSS_SELLS: 'crosssells',
  META: 'meta',
  EMAIL: 'email',
  ASSETS: 'assets',
  ADDED_PRODUCTS: 'addedEligibleProducts',
  FIRST_PRODUCT_WITH_COLORS: 'firstProductsWithColors',
  DEFAULT_PRODUCT: 'defaultProduct',
  AD_FACTORY: 'ad-factory',
};

export const statusEnum = {
  ALL: 'All',
  ACTIVE: 'Active',
  STARRED: 'Starred',
  ENDED: 'Ended',
  FAILED: 'Failed',
};

export const UTMTabs = {
  SOURCE: 'Source',
  MEDIUM: 'Medium',
  TERM: 'Term',
  CONTENT: 'Content',
};